import getErrorMessage from '../../../common/utils/getErrorMessage';
import Analytics from '../../../common/utils/analyticsUtil';
import notifyUser from '../../../common/utils/notifyUser';
import { NOTIFICATION_STATUS } from '../../../common/constants';
import { signoutUserOnAuthenticationFail } from './signoutUserOnAuthenticationFail';
export const signoutUser = payload => dispatch => {
    const { onSuccess, onError } = payload;
    dispatch({
        hmsFetchConfig: {
            path: '/hms_ms/api/v1/onboard/users/sign_out',
            method: 'POST',
            headers: {
                'oyo-intent': 'signOut',
            }
        },
        onSuccess: ({ data, store, next, actions }) => {
            Analytics.unregisterProperties();
            store.dispatch(signoutUserOnAuthenticationFail(payload, data));
            onSuccess && onSuccess();
        },
        onError: ({ store, error }) => {
            Analytics.setUserId(null);
            notifyUser({
                store,
                id: 'singout_error',
                status: NOTIFICATION_STATUS.ERROR,
                toast_text: getErrorMessage(error)
            });
            onError && onError(getErrorMessage(error));
        }
    });
}
